import { MediaLibraryState } from '../types'
import { MediaLibraryEssence } from '@/types/mediaLibrary'

const isLoading =
  (state: MediaLibraryState) =>
  (essence: MediaLibraryEssence): boolean => {
    return state.value.get(essence)?.loading ?? false
  }

export default isLoading
